import React from 'react';
import { Col, Row } from 'antd';

import IBStatistic from '@totem/components/ui_components/widgets/statistic/IBStatistic';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  totalCostSavings: number;
  totalEnergyCostSavings: number;
  totalDemandCostSavings: number;
  totalKwhSaved: number;
  totalPeakKwReduced: number;
  projectedAnnualSavings?: number;
  monthsActual?: number;
  monthsProjected?: number;
};

const formatCurrency = (val: number) =>
  `$${val.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const SavingsKPIs = ({
  totalCostSavings,
  totalEnergyCostSavings,
  totalDemandCostSavings,
  totalKwhSaved,
  totalPeakKwReduced,
  // projectedAnnualSavings,
  monthsActual,
  monthsProjected,
}: Props) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Total Cost Savings"
          subTitle={<span>&nbsp;</span>}
          value={formatCurrency(totalCostSavings)}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Energy Cost Savings"
          subTitle={<span>&nbsp;</span>}
          value={formatCurrency(totalEnergyCostSavings)}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Demand Cost Savings"
          subTitle={<span>&nbsp;</span>}
          value={formatCurrency(totalDemandCostSavings)}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="kWh Saved"
          subTitle={<span>&nbsp;</span>}
          value={totalKwhSaved.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
          valueSuffix=" kWh"
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Peak kW Reduced"
          subTitle={<span>&nbsp;</span>}
          value={totalPeakKwReduced.toLocaleString('en-US', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })}
          valueSuffix=" kW"
        />
      </Col>
      {/*{isNotNull(projectedAnnualSavings) && projectedAnnualSavings > 0 && (*/}
      {/*  <Col xs={24} sm={12} md={8} lg={6} xl={4}>*/}
      {/*    <IBStatistic*/}
      {/*      title="Projected Annual"*/}
      {/*      value={formatCurrency(projectedAnnualSavings)}*/}
      {/*      subTitle="annualized run rate"*/}
      {/*    />*/}
      {/*  </Col>*/}
      {/*)}*/}
      {(isNotNull(monthsActual) || isNotNull(monthsProjected)) && (
        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
          <IBStatistic
            title="Months"
            value={`${monthsActual ?? 0} actual`}
            subTitle={`${monthsProjected ?? 0} projected`}
          />
        </Col>
      )}
    </Row>
  );
};

export default SavingsKPIs;
